import { Component, OnInit, ViewChild } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginActivityService, LoginList } from './login-activity.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
interface PageEvent {
  first: number;
  rows: number;
}

@Component({
  selector: 'app-login-reports',
  templateUrl: './login-reports.component.html',
  styleUrls: ['./login-reports.component.scss'],
})
export class LoginReportsComponent implements OnInit {
  date!: string;
  firstIndex: number = 0;
  rows: number = 0;
  columns: any[] = [];
  loginTracks: LoginList[] = [];
  rowsPerPage: any;
  totalRecords: number = 0;
  lastIndex!: number;
  pageNumber!: number;
  isSearchListFetching: boolean = false;
  firstTimeSearch: boolean = false;
  currentSortField: string = 'lastAuthentication.asc';
  sortOrder: 'asc' | 'desc' | null = null;
  currentField: string = '';
  @ViewChild(Table) table: Table | undefined;

  searchForm: UntypedFormGroup = new UntypedFormGroup({
    selectedDates: new UntypedFormControl('', []),
    textValue: new UntypedFormControl('', []),
  });
  constructor(
    private spinner: NgxSpinnerService,
    private notifierService: NotifierService,
    private loginService: LoginActivityService,
    private datePipe: DatePipe
  ) {
    this.firstIndex = 0;
    this.rows = 10;
    this.columns = [
      {
        name: 'User Name',
        field: 'userName',
        sortable: true,
      },
      {
        name: 'IP Address',
        field: 'ipAddress',
        sortable: false,
      },
      {
        name: 'Last Authentication',
        field: 'lastAuthentication',
        sortable: true,
      },
    ];
  }

  ngOnInit(): void {
    this.handleGetSearchList();
    this.spinner.show();
    this.firstTimeSearch = true;
  }
  paginate(event: PageEvent): void {
    this.pageNumber = event.first / event.rows + 1;
  }
  clearText() {
    this.searchForm.controls['textValue'].patchValue('');
    this.searchForm.controls['selectedDates'].patchValue('');
  }
  handleGetSearchList() {
    this.spinner.show();
    this.isSearchListFetching = true;
    this.firstTimeSearch = false;

    const data = this.searchForm.getRawValue();
    this.loginService
      .getLoginActivityResult({
        userName: data.textValue,
        lastAuthentication: data.selectedDates,
      })
      .subscribe((data) => {
        this.loginTracks = [];
        this.handleSearchResponse(data);
        this.spinner.hide();
        this.isSearchListFetching = false;
        this.table?.reset();
      });
    this.spinner.hide();
  }
  handleSearchResponse(data: any) {
    this.loginTracks = data.map((item: LoginList) => {
      return {
        ...item,
        lastAuthentication: this.adjustDateToUserTimezone(
          item.lastAuthentication
        ),
      };
    });
  }
  adjustDateToUserTimezone(dateString: string): string {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(dateString);
    const userDate = new Date(
      date.toLocaleString('en-US', { timeZone: userTimezone })
    );
    return userDate.toLocaleString();
  }
  onSort(field: string) {
    if (this.currentField.includes(field)) {
      if (this.currentSortField == 'lastAuthentication.asc') {
        this.currentSortField = 'lastAuthentication.desc';
        return;
      }
      // Toggle sort order if the same field is sorted again
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      this.currentSortField = field + '.' + this.sortOrder;
    } else {
      // Set new field and default to ascending order
      this.sortOrder = 'asc';

      this.currentSortField = field + '.' + this.sortOrder;
    }
  }
}
